import { render, staticRenderFns } from "./BroadStationViewer.vue?vue&type=template&id=473d64b2&scoped=true"
import script from "./BroadStationViewer.vue?vue&type=script&lang=js"
export * from "./BroadStationViewer.vue?vue&type=script&lang=js"
import style0 from "./BroadStationViewer.vue?vue&type=style&index=0&id=473d64b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d64b2",
  null
  
)

export default component.exports